<script>
  export let message;
</script>

<style>
  .message :global(h2) {
    @apply text-3xl mb-6;
    font-family: Camphor W01 Bold;
    color: #00467f;
  }

  .message :global(strong) {
    @apply text-gray-700;
    font-family: Camphor W01 Bold;
  }

  .message :global(hr) {
    @apply my-8;
  }
</style>

<div class="p-8 pt-6 message">
  {@html message}
</div>